import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class OutsourcedUserFteSearchParams extends SearchParamsBase {
  constructor(userId) {
    super();
    this.UserId = userId || null;
  }

  initialize() {
    this.FieldworkOfficeId = '';
    this.FtePercentageFrom = '';
    this.FtePercentageTo = '';
    this.UseStartDateRange = false;
    this.StartDateFrom = dateTimeHelper.indefiniteDateValue();
    this.StartDateTo = dateTimeHelper.indefiniteDateValue();
    this.UseEndDateRange = false;
    this.EndDateFrom = dateTimeHelper.indefiniteDateValue();
    this.EndDateTo = dateTimeHelper.indefiniteDateValue();
    this.Statuses = [];
  }

  static fieldsInSearchBox = [
    { fieldName: 'FieldworkOfficeId', label: 'Office', className: 'col-3', type: InputTypesEnum.OfficeOrGroupSelect },
    {
      fieldName: 'Statuses',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.MultiChoice,
      options: OutsourcedUserFteSearchParams.getStatusOptions(),
    },
    { fieldName: 'FtePercentageFrom', label: 'FTE % From', className: 'col-3', type: InputTypesEnum.Number },
    { fieldName: 'FtePercentageTo', label: 'FTE % To', className: 'col-3', type: InputTypesEnum.Number },
    { fieldName: 'UseStartDateRange', label: 'Start Date Range', className: 'col-3', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDateFrom',
      label: 'Start Date From',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseStartDateRange,
    },
    {
      fieldName: 'StartDateTo',
      label: 'Start Date To',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseStartDateRange,
    },
    { fieldName: 'UseEndDateRange', label: 'End Date Range', className: 'col-3', type: InputTypesEnum.OnOff },
    {
      fieldName: 'EndDateFrom',
      label: 'End Date From',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseEndDateRange,
    },
    {
      fieldName: 'EndDateTo',
      label: 'End Date To',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseEndDateRange,
    },
  ];

  static getStatusOptions() {
    return [
      { label: 'Open', value: 'Open' },
      { label: 'Locked', value: 'Locked' },
      { label: 'Confirmed', value: 'Confirmed' },
      { label: 'Invoiced', value: 'Invoiced' },
    ];
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'OutsourcedUserFteSearchParams';
}
